<template>
  <div>
    <ArticleHeader :img_header="header_image" header="บทความ" link_back="managewebsite"/>
    <Article_manage/>
  </div>
</template>

<script>
import ArticleHeader from "@/components/admin/manage_website/article_setting/menu_article/ArticleHeader";
import HeaderImage from "@/assets/copywriting.png";
import Article_manage from "@/components/admin/manage_website/article_setting/Article_manage";
export default {
  name: "ArticleManage",
  components: {
    Article_manage,
    ArticleHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
